module.exports = __webpack_public_path__ + "img/logoPrincipalLinealBLANCO.bc8a121c.png";